import { Box, Stack, Typography } from "@mui/material"
import type React from "react"
import { formatDateOnly } from "../../utils/dates"
import { extraColors } from "../../utils/theme"
import type { NwssEventWindow } from "./nwssEventWindow"
import {
  bubbleDetectionFillColor,
  bubbleDetectionStrokeColor,
  bubbleDiameterPx,
} from "./nwssWeeklyCharts"

export const NWSS_EVENT_WINDOW_BAND_FILL = "rgba(255, 206, 100, 0.12)"

const legendLabelSx = {
  fontSize: "0.55rem",
  color: extraColors.translucent50,
  lineHeight: 1.2,
} as const

export interface NwssEventWindowLegendProps {
  eventWindow: NwssEventWindow
  /** Show a faded detection bubble sample (site swim-lane chart). */
  showOutsideBubbleGuide?: boolean
}

export const NwssEventWindowLegend: React.FC<NwssEventWindowLegendProps> = ({
  eventWindow,
  showOutsideBubbleGuide = false,
}) => {
  const rangeLabel = `${formatDateOnly(eventWindow.startDate)} – ${formatDateOnly(eventWindow.endDate)}`
  const outsideBubbleSize = bubbleDiameterPx(2)

  return (
    <Stack
      direction="row"
      useFlexGap
      sx={{ flexWrap: "wrap", alignItems: "center", gap: 1.5, mb: 0.75 }}
    >
      <Stack direction="row" sx={{ alignItems: "center", gap: 0.75 }}>
        <Box
          sx={{
            width: 22,
            height: 11,
            borderRadius: "2px",
            bgcolor: NWSS_EVENT_WINDOW_BAND_FILL,
            flexShrink: 0,
          }}
        />
        <Typography sx={legendLabelSx}>
          Event detection window ({rangeLabel})
        </Typography>
      </Stack>
      {showOutsideBubbleGuide && (
        <Stack direction="row" sx={{ alignItems: "center", gap: 0.75 }}>
          <Box
            component="span"
            sx={{
              width: outsideBubbleSize,
              height: outsideBubbleSize,
              borderRadius: "50%",
              bgcolor: bubbleDetectionFillColor(2),
              border: `1.5px solid ${bubbleDetectionStrokeColor(2)}`,
              opacity: 0.55,
              flexShrink: 0,
            }}
          />
          <Typography sx={legendLabelSx}>
            Detections outside window (faded)
          </Typography>
        </Stack>
      )}
    </Stack>
  )
}
